import { useCallback, useMemo, useSyncExternalStore } from 'react';

export const useMediaQuery = (query: string): boolean => {
  const media = useMemo(() => window.matchMedia(query), [query]);

  const subscribe = useCallback(
    (onChange: () => void) => {
      media.addEventListener('change', onChange);

      return () => {
        media.removeEventListener('change', onChange);
      };
    },
    [media],
  );

  const getSnapshot = useCallback(() => media.matches, [media]);

  return useSyncExternalStore(subscribe, getSnapshot);
};
